var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityLogsClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07666 13.7999L11.6502 12.4524V8.43945",
    stroke: "#29A471",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54308 5.92773C5.1911 6.34333 4.87875 6.78004 4.60693 7.24746",
    stroke: "#29A471",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51689 16.2189C4.23125 15.7016 3.98338 15.1411 3.80371 14.5508",
    stroke: "#29A471",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94043 20.4092L9.94965 20.4082C10.5587 20.5608 11.1927 20.6347 11.833 20.6328",
    stroke: "#29A471",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22158 3.43457C8.6632 3.62077 8.12418 3.86936 7.62109 4.17745",
    stroke: "#29A471",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8623 3.00004C12.5027 2.99812 13.1357 3.07202 13.7457 3.22463C14.6247 3.42811 15.4641 3.78707 16.2234 4.27273C16.6804 4.55491 17.1088 4.87932 17.4986 5.24693C18.1602 5.8612 18.7296 6.58489 19.1792 7.40264C19.475 7.92765 19.7137 8.48913 19.8942 9.07941C20.0325 9.51804 20.1375 9.9701 20.2085 10.4375C20.2794 10.9049 20.3135 11.3695 20.3117 11.8302C20.3154 12.5059 20.2407 13.147 20.0942 13.7824L20.0952 13.792C19.9007 14.7067 19.5543 15.5725 19.088 16.3633C18.8263 16.8384 18.5067 17.2857 18.1538 17.6917C17.5631 18.3808 16.8619 18.9845 16.0759 19.4529C15.571 19.7524 15.0329 20.0096 14.4746 20.1958",
    stroke: "#29A471",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47115 19.3484C7.02335 19.0739 6.59581 18.7504 6.20605 18.3828",
    stroke: "#29A471",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60008 9.83203C3.45265 10.4674 3.3817 11.1268 3.38539 11.8035",
    stroke: "#29A471",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5041 20.7542L14.4917 20.1765L15.0593 18.0938",
    stroke: "#29A471",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLogsClock);
export default __webpack_public_path__ + "static/media/ActivityLogsClock.87a98b01e56c0c93432d364bc44203da.svg";
export { ForwardRef as ReactComponent };